var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 3.83339C4.18018 3.83429 3.57577 3.84894 3.10727 4.08765C2.66823 4.31136 2.31127 4.66831 2.08757 5.10736C1.83325 5.60648 1.83325 6.25988 1.83325 7.56667V18.7667C1.83325 20.0735 1.83325 20.7269 2.08757 21.226C2.31127 21.665 2.66823 22.022 3.10727 22.2457C3.6064 22.5 4.2598 22.5 5.56659 22.5H14.4333C15.74 22.5 16.3934 22.5 16.8926 22.2457C17.3316 22.022 17.6886 21.665 17.9123 21.226C18.1666 20.7269 18.1666 20.0735 18.1666 18.7667V7.56667C18.1666 6.25988 18.1666 5.60648 17.9123 5.10736C17.6886 4.66831 17.3316 4.31136 16.8926 4.08765C16.4241 3.84894 15.8197 3.83429 14.6666 3.83339M5.33325 3.83339V6.16667H14.6666V3.83339M5.33325 3.83339V3.49162C5.33325 2.96341 5.54308 2.45684 5.91659 2.08333C6.29009 1.70983 6.79667 1.5 7.32488 1.5H12.675C13.2032 1.5 13.7098 1.70983 14.0833 2.08333C14.4568 2.45684 14.6666 2.96341 14.6666 3.49162V3.83339M14.6666 10.8333H12.3333M14.6666 16.6667H12.3333M5.33325 10.8333L6.49992 12L8.83325 9.66667M5.33325 16.6667L6.49992 17.8333L8.83325 15.5",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/formIcon.bf2b1928a96ea05a7a26b5be30fd3921.svg";
export { ForwardRef as ReactComponent };